import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filters-icon_d3b218589c6a3c0d25260346bd1f6cd5",
  "use": "filters-icon_d3b218589c6a3c0d25260346bd1f6cd5-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol viewBox=\"0 0 16 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"filters-icon_d3b218589c6a3c0d25260346bd1f6cd5\">\n<path d=\"M6.33333 10H9.66667V8.33333H6.33333V10ZM0.5 0V1.66667H15.5V0H0.5ZM3 5.83333H13V4.16667H3V5.83333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol